module.exports = __webpack_public_path__ + "img/蒙版分组 (3).fddefbd3.png";